import { render, staticRenderFns } from "./ApprovalNodeConfig.vue?vue&type=template&id=f36ef876&scoped=true&"
import script from "./ApprovalNodeConfig.vue?vue&type=script&lang=js&"
export * from "./ApprovalNodeConfig.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalNodeConfig.vue?vue&type=style&index=0&id=f36ef876&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36ef876",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-sub-design\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f36ef876')) {
      api.createRecord('f36ef876', component.options)
    } else {
      api.reload('f36ef876', component.options)
    }
    module.hot.accept("./ApprovalNodeConfig.vue?vue&type=template&id=f36ef876&scoped=true&", function () {
      api.rerender('f36ef876', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/process/comon/process/config/ApprovalNodeConfig.vue"
export default component.exports